import * as React from 'react';
import { useAudio } from '@/context/AudioContext';
import { useTranslation } from 'next-i18next';

export default function SoundSettings() {
  const {
    bgmVolume,
    soundEffectVolume,
    changeBGMVolume,
    changeSoundEffectVolume,
  } = useAudio();

  const { t } = useTranslation();

  const handleChangeBGMVolume = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseFloat(e.target.value);
    changeBGMVolume(newVolume);
  };

  const handleChangeSoundEffectVolume = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const newVolume = parseFloat(e.target.value);
    changeSoundEffectVolume(newVolume);
  };

  return (
    <div className="flex flex-col justify-center gap-12 h-full">
      <div className="flex flex-col justify-center gap-2 p-2">
        <div className="flex items-center justify-center gap-4 mb-2 text-xl font-medium">
          <div className="w-[80px] text-center tracking-widest">BGM</div>
          <input
            id="volume"
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={bgmVolume}
            className="custom-range w-[50%] h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
            onChange={handleChangeBGMVolume}
          ></input>
          <div className="w-[60px]">
            {bgmVolume ? Math.round(bgmVolume * 100) : '-'}
          </div>
        </div>

        <div className="flex items-center justify-center gap-4 mb-2 text-xl font-medium">
          <div className="w-[80px] text-center">
            {t('options.sound.soundEffect')}
          </div>
          <input
            id="volume"
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={soundEffectVolume}
            className="custom-range w-[50%] h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
            onChange={handleChangeSoundEffectVolume}
          ></input>
          <div className="w-[60px]">
            {soundEffectVolume ? Math.round(soundEffectVolume * 100) : '-'}
          </div>
        </div>
      </div>
    </div>
  );
}
